import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin, Lock } from 'lucide-react';
import { teamInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="network-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_panthers-league/artifacts/h32tep3p_New%20Panthers%20Logo.jpg" 
              alt="Randallstown Panthers Logo" 
              className="footer-logo"
            />
            <h3>Randallstown Youth Football & Cheer Organization</h3>
            <p>Building Champions On and Off the Field Since 1979</p>
          </div>
          
          <div className="footer-links">
            <h4>Quick Links</h4>
            <Link to="/about">About Us</Link>
            <Link to="/programs">Programs</Link>
            <Link to="/registration">Registration</Link>
            <Link to="/sponsorship">Sponsorship</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/past-events" data-testid="footer-past-events-link">Past Events</Link>
            <Link to="/admin" className="admin-footer-link">
              <Lock size={14} />
              Admin Dashboard
            </Link>
          </div>
          
          <div className="footer-links">
            <h4>Programs</h4>
            <Link to="/programs">Tackle Football</Link>
            <Link to="/programs">Flag Football</Link>
            <Link to="/programs">Girls Flag Football</Link>
            <Link to="/programs">Cheerleading</Link>
            <Link to="/programs">NFL FLAG</Link>
          </div>
          
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <div className="footer-contact-item">
              <Mail size={16} />
              <a href={`mailto:${teamInfo.email}`}>{teamInfo.email}</a>
            </div>
            <div className="footer-contact-item">
              <Phone size={16} />
              <a href={`tel:${teamInfo.phone.coach_chris}`}>{teamInfo.phone.coach_chris}</a>
            </div>
            <div className="footer-contact-item">
              <MapPin size={16} />
              <span>{teamInfo.address}</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>© {new Date().getFullYear()} Randallstown Youth Football & Cheer Organization. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/admin" className="admin-link">
                <Lock size={14} />
                Admin
              </Link>
              <div className="social-links">
                <a href={teamInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Facebook size={20} />
                </a>
                <a href={teamInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
